export default "__VITE_ASSET__BwwOqym5__"